// Load Flatpickr with needed locales and export it for global access

import flatpickr from 'flatpickr';

import { Slovak } from 'flatpickr/dist/l10n/sk.js';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import { Hungarian } from 'flatpickr/dist/l10n/hu.js';
import { Polish } from 'flatpickr/dist/l10n/pl.js';
import { Croatian } from 'flatpickr/dist/l10n/hr.js';
import { German } from 'flatpickr/dist/l10n/de.js';

const flatpickrLocaleMap = {
	cs: Czech,
	sk: Slovak,
	hu: Hungarian,
	pl: Polish,
	cro: Croatian,
	de: German,
};

const siteLang = document.querySelector('html').getAttribute('lang') || 'en';

window.flatpickr = flatpickr;
window.flatpickrLocale = (locale = siteLang) => flatpickrLocaleMap[locale] || flatpickrLocaleMap.cs;
